import request from '@/utils/request';

export const pkQuoteCreate = async (data: any) => {
    return request.post(`/pkQuote/create`, {
        data: data,
    });
};
